import { useCallback } from 'react';

import { Station } from 'dataSources/Typicode/stations';
import { IStationListResponse } from 'dataSources/Typicode/stations';

import { useFilterStationsByPoint } from './useFilterStationsByPoint';
import { useGetRouteStationsPricesByStationCode } from "entities/stations";
import { useRoutesContext } from 'common/context/routes';

import { getStationServicePriceByPriceType } from 'entities/stations';

const sortByPrice =
  (serviceCodes: number[], priceType: string) =>
  (firstRouteStation: IStationListResponse, secondStations: IStationListResponse) => {
    const firstService = firstRouteStation.services.find(
      //@ts-expect-error разобраться с типами должен быть number
      ({ service }) => serviceCodes[0] === service.code
    );
    const secondService = secondStations.services.find(
      //@ts-expect-error разобраться с типами должен быть number
      ({ service }) => serviceCodes[0] === service.code
    );

    if (
      !getStationServicePriceByPriceType(priceType, firstService) ||
      !getStationServicePriceByPriceType(priceType, secondService)
    ) {
      return 1;
    }

    return Number(getStationServicePriceByPriceType(priceType, firstService).amount) > Number(getStationServicePriceByPriceType(priceType, secondService).amount) ? 1 : -1;
  };

export const useFilterTopPriceEvery100kmActiveFilter = () => {
  const filterStationsByPoint = useFilterStationsByPoint();
  const { activeRoute } = useRoutesContext();

  const getRouteStationsPricesByStationCode = useGetRouteStationsPricesByStationCode();


  const filterTopPriceEvery100kmActiveFilter = useCallback((
    stations: Station[],
    serviceCodes: number[],
    priceType: string
  ) => {
    const stationsByPoints = filterStationsByPoint(
      //@ts-expect-error every100 exist type
      activeRoute.every100,
      stations
    );

    return stationsByPoints
      .map((stations) => {
        if (stations.length === 0) {
          return null;
        }

        const [bestPriceStation] = stations
          .reduce((acc, { code }) => {
            const item = getRouteStationsPricesByStationCode(code);

            if (item) {
              acc.push(item)
            }

            return acc;
          }, [] as IStationListResponse[])
          .sort(sortByPrice(serviceCodes, priceType));

        return stations.find(({ code }) => code === (bestPriceStation || {}).stationInternalId)!;
      })
      .filter((s) => s !== null);
  }, [
    filterStationsByPoint,
    activeRoute,
    getRouteStationsPricesByStationCode
  ]);

  return filterTopPriceEvery100kmActiveFilter;
};
